<template>
  <div class="attachment-list">
    <!-- <div class="attachment-item" v-for="(item,index) of question.file" :key="index">
      <img class="file-icon" src="@/assets/img/file.png" />
      <div class="upload-status">
        <div class="attachment-name">{{ item.title }}</div>
        <div class="progress">
          <span>大小：{{item.size}}M</span>
          <img class="close-icon" src="@/assets/images/download.png" @click="downloadFile(item.url)" />
        </div>
      </div>
    </div> -->
    <div v-if="question.type==4">
      <div class="attachment-item" v-for="(item,index) of question.file" :key="index" @click="downloadFile(item.url)">
        <img class="file-icon" :src="require(`@/assets/images/homeWork/${getFileType(item.title)}.png`)" />
        <div class="upload-status">
          <div class="attachment-name">
            <span class="attachment-name-left">{{ item.title.split('.')[0] }}</span>
            <span>.{{ item.title.split('.')[1] }}</span>
          </div>
          <div class="progress" v-if="item.size">
            <span>{{item.size}}M</span>
          </div>
          <div class="progress" v-else-if="item.progress">
              <span>{{(item.progress.total/(1024*1024)).toFixed(2)}}M</span>
          </div>
        </div>
        <!-- <img class="close-icon" src="@/assets/images/download.png"  /> -->
      </div>
    </div>
    <div v-if="question.type!=4">
        <!-- <img class="topic-img" v-for="(item,index) of question.file" :key="index" :src="item.url" @click="imgPreview(item)" alt=""> -->
			<div class="topic-img" v-for="(item,index) of question.file" :key="index" :style="{backgroundImage:`url(${item.url})`}" @click="imgPreview(item)"></div>

    </div>
    <van-image-preview v-model="show" :images="image" @close="imgPreviewClose">
    </van-image-preview>
    </div>
</template>

<script>
import { getFileType } from '@/utils/index.js'
export default {
  props: {
    question: {
			type: Object,
			default: () => ({ type: 0, title: '' })
		},
   },
  data () {
    return { 
      image:[],
      show:false
    }
  },
  computed: { },
  watch: { },
  methods: {
    getFileType,
    downloadFile(url){
      window.open(url)
    },
     imgPreview(item){
      this.show=true
      this.image.push(item.url)
      console.log(this.image);
    },
    imgPreviewClose(){
      this.image=[]
      this.show=false
    }
   },
  mounted() { }
}
</script>

<style lang="scss" scoped>
.attachment-list{
  box-sizing: border-box;
  .attachment-item{
    // height: 64px;
    display: flex;
    align-items: center;
    box-sizing: border-box;
    padding: 4px 8px 4px 4px;
    background-color: #F4F6F6;
    margin-bottom: 8px;
    border-radius: 8px;
    .attachment-name{
      overflow:hidden;
      text-overflow:ellipsis;
      white-space:nowrap;
      display: flex;
      align-items: center;
    }
    .attachment-name-left {
      display: inline-block;
      max-width: 220px;
      overflow:hidden;
      text-overflow:ellipsis;
      white-space:nowrap
    }
    .file-icon{
      width: 24px;
      height: 24px;
      margin-right: 4px;
    }
    .upload-status{
      display: flex;
      flex: 1;
      justify-content: space-between;
      align-items: center;
      .progress{
        display: flex;
        align-items: center;
        max-width: 275px;
        ::v-deep .el-progress-bar__outer{
          background-color:#ffffff;
        }
        span{
          font-size: 12px;
          color: #888888;
        }
      }
    }
    .close-icon{
      width: 16px;
      height: 16px;
      margin-left: auto;
      cursor: pointer;
    }
  }
    .topic-img{
    width: 106px;
    height: 60px;
    border-radius: 6px;
    display: flex;
    flex-wrap: wrap;
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
  }
}
</style>
